import { usePublicDb } from "@in-and-out-belleza/api/resources"
import { getCartGrouped } from "@in-and-out-belleza/api/utils"

export const useCartGrouped = (cart: Array<string>) => {
  const { db } = usePublicDb()
  return getCartGrouped(db, cart)
}
